import { ErrorHandler, NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  ErrorStateMatcher,
  ShowOnDirtyErrorStateMatcher,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env';
import {
  AI_CHAT_PROVIDERS,
  AiChatLauncherComponent,
  DOTLOTTIE_LOADER,
} from '@qtek/libs/ai-chat';
import { HideLoaderGuard, QtDateAdapter } from '@qtek/libs/app-component';
import { KeyboardModule } from '@qtek/libs/keyboard';
import { LayoutModule } from '@qtek/libs/layout';
import {
  PermissionBadgeDirective,
  PermissionDirective,
} from '@qtek/libs/permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ChunkLoadErrorHandler } from './chunk-load-error-handler';
import { DealRouteReuseStrategy } from './deal-route-reuse.strategy';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    LayoutModule,
    MatSnackBarModule,
    KeyboardModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatSelectModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
    PermissionDirective,
    PermissionBadgeDirective,
    AiChatLauncherComponent,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    // Ensure you are importing and providing the correct state and effects
    HideLoaderGuard,
    { provide: DateAdapter, useExisting: QtDateAdapter },
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 500,
        hideDelay: 0,
        touchendHideDelay: 1500,
      },
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 2000,
      },
    },
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    { provide: RouteReuseStrategy, useClass: DealRouteReuseStrategy },
    AI_CHAT_PROVIDERS,
    {
      provide: DOTLOTTIE_LOADER,
      useValue: () => import('@lottiefiles/dotlottie-web'),
    },
  ],
})
export class AppModule {}
